import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="bg-brand-carbon" data-id="element-73" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-xl px-3 py-4 text-center sm:px-5" data-id="element-74" data-mp="3ggk8mvu5ve02">
        <p className="text-[0.68rem] leading-snug text-white/70" data-id="element-75" data-mp="32ovvqqc38li1">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mt-1.5 text-[0.64rem] leading-snug text-white/60" data-id="element-76" data-mp="36ppj9ilmbyae">
          {PRODUCT_NAME}™ es un producto educativo. No sustituye formación
          profesional, práctica supervisada, manuales de fabricantes, normativa
          eléctrica, seguridad industrial, licencias, certificaciones, permisos
          ni el criterio de un profesional habilitado. Toda práctica o
          intervención sobre equipos reales debe realizarse únicamente sobre
          sistemas propios o expresamente autorizados y siguiendo las normas y
          procedimientos de seguridad aplicables.
        </p>
        <p className="mt-1.5 text-[0.68rem] text-white/75" data-id="element-77" data-mp="2ezl541ogc7hm">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-brand-yellow transition-colors duration-150 ease-soft hover:text-white" data-id="element-78" data-mp="3la2akxul99wt">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1.5 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 text-[0.68rem] text-white/75" data-id="element-79" data-mp="3v5dhitzr9cu0">
          <a href="#terminos" className="transition-colors duration-150 ease-soft hover:text-brand-yellow" data-id="element-80" data-mp="80xjc6sbqxik">
            Términos y Condiciones
          </a>
          <span className="text-white/40" data-id="element-81" data-mp="hs1wr22cqaba">•</span>
          <a href="#privacidad" className="transition-colors duration-150 ease-soft hover:text-brand-yellow" data-id="element-82" data-mp="ct77bh9vpni7">
            Política de Privacidad
          </a>
          <span className="text-white/40" data-id="element-83" data-mp="msg8au35w2e2">•</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors duration-150 ease-soft hover:text-brand-yellow" data-id="element-84" data-mp="mtrbaros9644">
            Contacto
          </a>
        </nav>
      </div>
    </footer>;
}